import { useEffect, useState } from "react";
import { getSettings } from "@/lib/api";

export default function TrackingScripts() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (loaded) return;

    async function loadTracking() {
      try {
        const res = await getSettings();
        const s = res.data;

        const gaId = s?.ga_measurement_id || process.env.REACT_APP_GA_ID;
        const gadsId = s?.google_ads_id || process.env.REACT_APP_GADS_ID;
        const pixelId = s?.meta_pixel_id || process.env.REACT_APP_META_PIXEL_ID;

        // Defer all tracking to after page is interactive
        const injectAfterIdle = (fn) => {
          if (window.requestIdleCallback) window.requestIdleCallback(fn);
          else setTimeout(fn, 100);
        };

        injectAfterIdle(() => {
          // Google Analytics (gtag.js)
          if (gaId) {
            const gtagScript = document.createElement("script");
            gtagScript.async = true;
            gtagScript.defer = true;
            gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
            document.head.appendChild(gtagScript);

            const inlineScript = document.createElement("script");
            inlineScript.defer = true;
            inlineScript.textContent = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${gaId}');
              ${gadsId ? `gtag('config', '${gadsId}');` : ""}
            `;
            document.head.appendChild(inlineScript);
          }

          // Google Ads (standalone if no GA but has Ads ID)
          if (gadsId && !gaId) {
            const gadsScript = document.createElement("script");
            gadsScript.async = true;
            gadsScript.defer = true;
            gadsScript.src = `https://www.googletagmanager.com/gtag/js?id=${gadsId}`;
            document.head.appendChild(gadsScript);

            const inlineScript = document.createElement("script");
            inlineScript.defer = true;
            inlineScript.textContent = `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${gadsId}');
            `;
            document.head.appendChild(inlineScript);
          }

          // Meta Pixel (ensure single init)
          if (pixelId && !window.fbq) {
            const fbScript = document.createElement("script");
            fbScript.defer = true;
            fbScript.textContent = `
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '${pixelId}');
              fbq('set', 'autoConfig', false, '${pixelId}');
              fbq('track', 'PageView');
            `;
            document.head.appendChild(fbScript);
          }
        });

        setLoaded(true);
      } catch (err) {
        console.error("Tracking scripts failed to load:", err);
      }
    }

    loadTracking();
  }, [loaded]);

  return null;
}
